import type { Business } from '../types/business'

function definirMeta(atributo: 'property' | 'name', chave: string, valor: string): void {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${atributo}="${chave}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(atributo, chave)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', valor)
}

export function aplicarPreviewSocial(b: Business): void {
  const titulo = `${b.profissional} — ${b.especialidade}`
  const descricao = b.bio

  document.title = titulo

  definirMeta('name', 'description', descricao)
  definirMeta('property', 'og:type', 'website')
  definirMeta('property', 'og:site_name', b.nome)
  definirMeta('property', 'og:title', titulo)
  definirMeta('property', 'og:description', descricao)
  definirMeta('property', 'og:image', b.imagemCompartilhamento)
  definirMeta('property', 'og:image:width', '1280')
  definirMeta('property', 'og:image:height', '720')
  definirMeta('property', 'og:image:alt', `${b.profissional} no consultório do ${b.nome}`)
  definirMeta('property', 'og:url', window.location.href)
  definirMeta('name', 'twitter:card', 'summary_large_image')
  definirMeta('name', 'twitter:title', titulo)
  definirMeta('name', 'twitter:description', descricao)
  definirMeta('name', 'twitter:image', b.imagemCompartilhamento)
}
